<template>
  <div>
<!--    <header class="bar bar-nav">-->
<!--      <a class="icon icon-left pull-left" @click="tolast"></a>-->
<!--      <h1 class="title">账单分类</h1>-->
<!--    </header>-->


    <div class="content">
      <div v-if="showComp" style="margin-top:60px;">
        <ChooseResearchGroup @updateDefaultIndex="updateDefaultIndex" :researchGroupList="researchGroupList" :defaultIndex="defaultIndex" />
      </div>
      <div>
        <div class="list-block" style="margin-top:60px">
          <div class="content-block-title" style="margin:0px;margin-bottom:10px;font-size:.8rem">请选择时间</div>
          <ul>
            <li>
              <div class="item-content">
                <!--              <div class="item-media"><i class="icon icon-form-toggle"></i></div>-->
                <div class="item-inner">
                  <div class="item-title label">分类</div>
                  <div class="item-input">
                    <select v-model="selected" >
                      <option value="月度">月度</option>
                      <option value="年度">年度</option>
                      <option value="累计">累计</option>
                    </select>
                  </div>
                </div>
              </div>
            </li>
            <!-- Date -->
            <li v-if="selected !== '累计'">
              <div class="item-content">
                <!--              <div class="item-media"><i class="icon icon-form-calendar"></i></div>-->
                <div class="item-inner">
                  <div class="item-title label">日期</div>
                  <div class="item-input">
                    <!--                  <input type="date" placeholder="Birth day" value="2014-04-03" v-model="chooseDate">-->
                    <ul class="toleft" style="height: 60px; padding-left: 0;">
                      <li>
                        <select v-model="year" >
                          <option value="2020">2020</option>
                          <option value="2019">2019</option>
                          <option value="2018">2018</option>
                          <option value="2017">2017</option>
                          <option value="2016">2016</option>
                          <option value="2015">2015</option>
                          <option value="2014">2014</option>
                          <option value="2013">2013</option>
                          <option value="2012">2012</option>
                          <option value="2011">2011</option>
                          <option value="2010">2010</option>
                          <option value="2009">2009</option>
                          <option value="2008">2008</option>
                          <option value="2007">2007</option>
                          <option value="2006">2006</option>
                          <option value="2005">2005</option>
                          <option value="2004">2004</option>
                          <option value="2003">2003</option>
                          <option value="2002">2002</option>
                        </select>
                      </li>
                      <li>年</li>
                      <li v-if="selected === '月度'">
                        <select v-model="month" >
                          <option value="01">01</option>
                          <option value="02">02</option>
                          <option value="03">03</option>
                          <option value="04">04</option>
                          <option value="05">05</option>
                          <option value="06">06</option>
                          <option value="07">07</option>
                          <option value="08">08</option>
                          <option value="09">09</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                        </select>
                      </li>
                      <li v-if="selected === '月度'">月</li>
                    </ul>

                  </div>

                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="content-block">
          <div class="content-block">
            <p><a class="button button-big button-fill" @click="toBillChecked()">查看</a></p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import EMKT from '../../../emkt.js'
import ChooseResearchGroup from '../MyResearchGroup/researchGroupComponents/ChooseResearchGroup'
import $ from 'jquery'
// import $
export default {
  name: 'ChooseBillType',
  props: {
    showComp: Boolean,
    researchGroupList: {}
  },
  components: {
    ChooseResearchGroup
  },
  data () {
    return {
      selected: '月度',
      chooseDate: '2020-01',
      year: '2020',
      month: '01',
      billInfo: {},
      defaultIndex: 0
    }
  },
  mounted () {
    console.log('课题组列表:', this.researchGroupList)
  },
  watch: {
    'selected': function (val) {
      if (val === '累计') {
        this.year = ''
        this.month = ''
      } else if (val === '年度') {
        this.month = ''
      }
    }
  },
  methods: {
    toBillChecked: function () {
      this.changeChooseDate()
      // 获取账单数据
      if (this.researchGroupList.length > 0) {
        var params = this.researchGroupList[this.defaultIndex].researchGroupNo + ',' + this.chooseDate
        // var params = '00000004,2020-02'
        console.log('params->' + params)
        this.gcapi('loadResearchGroupBillInfo', params).then((res) => {
          console.log('res.body.result：', JSON.parse(res.body.result))
          var mes = JSON.parse(res.body.result)
          if (!mes.result) {
            $.toast('课题组编号不存在')
            return
          }
          const obj = JSON.parse(JSON.parse(res.body.result).json)
          console.log('账单对象：', obj)
          this.billInfo = obj
          EMKT.setStoreItem('billInfo', obj)
          var _this = this
          if (_this.selected === '累计') {
            _this.$router.push({name: 'AccountChecked', query: {type: _this.selected, groupName: this.researchGroupList[this.defaultIndex].researchGroupName}})
          } else {
            _this.$router.push({name: 'AccountChecked', query: {type: _this.selected, chooseDate: _this.chooseDate, groupName: this.researchGroupList[this.defaultIndex].researchGroupName}})
          }
        })
      }
    },
    updateDefaultIndex (index) {
      console.log('update', index)
      this.defaultIndex = index
    },
    tolast () {
      this.$router.push({name: 'me'})
    },
    changeChooseDate () {
      if (this.selected === '月度') {
        this.chooseDate = this.year + '-' + this.month
      } else if (this.selected === '年度') {
        this.chooseDate = this.year
      } else {
        this.chooseDate = ''
      }
    }
  }

}
</script>

<style scoped>
.toleft li{
  float: left;
  line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// ChooseBillType.vue?dadb938e